import styles from './DescriptionDetails.module.scss';

interface Props {
  children?: React.ReactNode;
}

const DescriptionDetails: React.FC<Props> = ({ children }) => (
  <div className={styles.wrapper} data-dd-action-name="DescriptionDetails">
    {children}
  </div>
);

export default DescriptionDetails;
